var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-badge"},[_vm._v(" "+_vm._s(_vm.initials)+" "),(_vm.imageSrc)?_c('AsyncImage',{staticClass:"user-badge-photo",attrs:{"src":_vm.imageSrc,"alt":"Profile Picture"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }